module.exports = __webpack_public_path__ + "img/svg/background-user-rankings-crown.1d7b10afc26c214bf052033e0c302ea2.svg";